@if (ready) {
  <app-ui-tour></app-ui-tour>
  <app-menu class="menu" appUiTour="menu"></app-menu>
  <main>
    <app-loader class="loader" [ngClass]="{ hidden: !loading }"></app-loader>
    <router-outlet></router-outlet>
  </main>
  <app-snackbar class="snackbar"></app-snackbar>
}
